/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.documents.WriterRole
*/
export var WriterRole;
(function (WriterRole) {
    WriterRole["AI"] = "AI";
    WriterRole["USER"] = "USER";
    WriterRole["KIT"] = "KIT";
})(WriterRole || (WriterRole = {}));
//# sourceMappingURL=WriterRole.js.map